import { Banner, ClassicCard } from '@braze/web-sdk';

export enum BrazeCardCustomType {
  HomePageBanner = 'homePageBanner',
  ProTimelineBanner = 'timelineBanner',
}
export type BrazeCard = Banner | ClassicCard;
export type BrazeContentCardFilterFn = (cards: BrazeCard) => boolean;
export type BrazeFeedFilter = BrazeCardCustomType | BrazeContentCardFilterFn;
export type BrazeCardEvent = { card: BrazeCard };

export type BrazeContentCardFeedContextType = {
  cards: BrazeCard[];
  markCardAsViewed: (e: BrazeCardEvent) => void;
  selectCard: (e: BrazeCardEvent) => void;
};
